import testListService from "./testListService";

const testPrintService = [
    ...testListService
];

export { testPrintService as default, testListService }